import { all, put, call, takeEvery, select, spawn } from 'redux-saga/effects'
import Auth from '@aws-amplify/auth'
import DeviceActions from './actions'
import {
  // getDeviceActivity,
  getClinicDeviceActivity,
  addDevice,
  getAllInventoryDevices,
  updateDevice,
  addDeviceInInventory,
  assignDeviceToProvider,
  deleteDevice,
  // CMS DEVICE APIs
  getDeviceDetail,
  returnDevice,
  linkPatient,
  getDevicePatientsList,
  changeDeviceName,
  getDashboardDevices,
  getInventoryDevices,
  deviceSetState,
  profileSetState,
  clinicPatientSetState,
} from '../actions'
import { GET_AVAILABLE_DEVICES, GET_CLINIC_PATIENTS } from '../clinicPatient/sagas'
import { LISTEN_TO_DB_SOCKET, CLOSE_DB_SOCKET } from '../dashboadLiveRR/sagas'
import { GET_CLINIC_PATIENTS_DB } from '../dashboard/sagas'
import { formatDeviceMetrics, analytics, http, notification } from '../../services'
import { newAPIPaths } from '../../config'

const getUser = (state) => state.user
const getClinic = (state) => state.clinic
const getDevice = (state) => state.device

// API call to get a List of All Devices filtered by the current loggeed in Provider if a Provider is logged in, or unfiltered if Superadmin is logged in.
export const getAllDevices = async (payload) =>
  http
    .get(
      newAPIPaths.getAllDevice,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const getAllDevicesWithoutPagination = async (payload) =>
  http
    .get(
      newAPIPaths.getAllDeviceWithoutPagination,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const getDevicesRecords = async (payload) =>
  http
    .get(
      newAPIPaths.getDeviceRecord,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const updateDevicesRecordsStatus = async (payload) =>
  http
    .post(
      `${newAPIPaths.updateDeviceRecordStatus}?record_id=${payload.recordId}&record_status=${payload.record_status}`,
      { data: payload.data },
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => {
      notification.success('Success', 'Devices Status Updated successfully')
      return {
        res: res.data,
      }
    })
    .catch((err) => {
      const {
        response: {
          data: { detail },
        },
      } = err
      notification.error(`Something went wrong`, detail || `Please contact support!`)
      return { err }
    })

export const getDevicesInventory = async (payload) =>
  http
    .get(
      newAPIPaths.getDeviceInventory,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { detail },
        },
      } = err
      notification.error(`Something went wrong`, detail || `Please contact support!`)
      return { err }
    })

export const updateDevicesInventoryStatus = async (payload) =>
  http
    .post(
      `${newAPIPaths.updateDeviceInventoryStatus}?record_id=${payload.recordId}&record_status=${payload.record_status}`,
      { data: payload.data },
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => {
      notification.success('Success', 'Devices Status Updated successfully')
      return {
        res: res.data,
      }
    })
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const getDevicesConnection = async (payload) =>
  http
    .get(
      newAPIPaths.getDeviceConnection,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const getDevicesMetrics = async () =>
  http
    .get(
      newAPIPaths.getDevicesMetrics,
      {},
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({ res: res.data }))
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const addSingleDevice = async (payload) =>
  http
    .post(
      newAPIPaths.createSingleDevice,
      payload,
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => {
      notification.success('Success', 'Devices added successfully')
      return { res: res.data }
    })
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const addMultipleDevice = async (payload) =>
  http
    .post(
      newAPIPaths.createMultipleDevice.replace('{clinic_id}', payload.clinic_id),
      { data: payload.data },
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => {
      notification.success('Success', 'Devices added successfully')
      return {
        res: res.data,
      }
    })
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

export const replaceDevices = async (payload, retry = false, forceCreate = false) =>
  http
    .post(
      newAPIPaths.modifyReplaceDevicesRaw.replace('{clinic_id}', payload.clinic_id),
      { data: payload.data, retry, force_create: forceCreate },
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => ({
      res,
    }))
    .catch((err) => ({ err }))

export const removeDevice = async (payload) =>
  http
    .post(
      newAPIPaths.removeDevice
        .replace('{clinic_id}', payload.clinic_id)
        .replace('{device_id}', payload.device_id),
      { data: payload.data },
      { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
      'newAPIDomain',
    )
    .then((res) => {
      notification.success('Success', 'Device removed successfully')
      return {
        res: res.data,
      }
    })
    .catch((err) => {
      const {
        response: {
          data: { message },
        },
      } = err
      notification.error(`Something went wrong`, message || `Please contact support!`)
      return { err }
    })

// Function to get A List of Devices from Server and Save it in Redux Store
export function* GET_DEVICES({ payload }) {
  yield put(deviceSetState({ loading: true }))
  const { res, err } = yield call(getAllDevices, payload)
  if (err) return yield put(deviceSetState({ loading: false, devices: [] }))
  yield put(deviceSetState({ loading: false, devices: res.data, totalDevices: res.total_records }))
}

export function* GET_DEVICES_RECORDS({ payload }) {
  yield put(deviceSetState({ loading: true }))
  const { res, err } = yield call(getDevicesRecords, payload)
  if (err) return yield put(deviceSetState({ loading: false, devicesRecord: [] }))

  yield put(
    deviceSetState({
      loading: false,
      devicesRecord: res.data,
      totalDevicesRecord: res.total_records,
    }),
  )
}

export function* UPDATE_DEVICES_RECORDS_STATUS({ payload }) {
  const { devicesRecord } = yield select(getDevice)
  const { err } = yield call(updateDevicesRecordsStatus, payload)
  if (err) return

  const tempDevicesRecord = devicesRecord
  const index = tempDevicesRecord.findIndex((item) => item.id === payload.recordId)
  tempDevicesRecord[index] = {
    ...tempDevicesRecord[index],
    record_status: payload.record_status === 'current' ? 'current' : 'previous',
  }

  yield put(
    deviceSetState({
      devicesRecord: tempDevicesRecord,
    }),
  )
}

export function* GET_DEVICES_INVENTORY({ payload }) {
  yield put(deviceSetState({ loading: true }))
  const { res, err } = yield call(getDevicesInventory, payload)
  if (err) return yield put(deviceSetState({ loading: false, devicesInventory: [] }))
  yield put(
    deviceSetState({
      loading: false,
      devicesInventory: res.data,
      totalDevicesInventory: res.total_records,
    }),
  )
}

export function* UPDATE_DEVICES_INVENTORY_STATUS({ payload }) {
  const { devicesInventory } = yield select(getDevice)
  const { err } = yield call(updateDevicesInventoryStatus, payload)
  if (err) return

  const tempDevicesInventory = devicesInventory
  const index = tempDevicesInventory.findIndex((item) => item.id === payload.recordId)
  tempDevicesInventory[index] = {
    ...tempDevicesInventory[index],
    record_status: payload.record_status === 'active' ? 'active' : 'inactive',
  }

  yield put(
    deviceSetState({
      devicesInventory: tempDevicesInventory,
    }),
  )
}

export function* GET_DEVICES_CONNECTION({ payload }) {
  yield put(deviceSetState({ loading: true }))
  const { res, err } = yield call(getDevicesConnection, payload)
  if (err) return yield put(deviceSetState({ loading: false, devicesConnection: [] }))
  yield put(
    deviceSetState({
      loading: false,
      devicesConnection: res.data,
      totalDevicesConnection: res.total_records,
    }),
  )
}

export function* GET_DEVICES_METRICS() {
  yield put(deviceSetState({ deviceMetrics: {}, deviceMetricsLoading: true }))
  const { res: deviceMetrics, err } = yield call(getDevicesMetrics)
  if (err) return yield put(deviceSetState({ deviceMetrics: [], deviceMetricsLoading: false }))
  yield put(deviceSetState({ deviceMetrics, deviceMetricsLoading: false }))
}

export function* ADD_SINGLE_DEVICE({ payload }) {
  yield put(deviceSetState({ loading: true, addSingleDeviceStatus: 'please wait' }))
  const { err } = yield call(addSingleDevice, payload)
  if (err) return yield put(deviceSetState({ loading: false, addSingleDeviceStatus: 'error' }))
  const payloadData = JSON.parse(sessionStorage.getItem('tableState'))
  if (payloadData !== null) {
    yield call(GET_DEVICES, { payload: payloadData })
    yield call(GET_DEVICES_METRICS)
  }
  yield put(deviceSetState({ loading: false, addSingleDeviceStatus: 'success' }))
}

export function* ADD_MULTIPLE_DEVICE({ payload }) {
  yield put(deviceSetState({ loading: true, addMultipleDeviceStatus: 'please wait' }))
  const { err } = yield call(addMultipleDevice, payload)
  if (err) return yield put(deviceSetState({ loading: false, addMultipleDeviceStatus: 'error' }))
  yield call(GET_DEVICES, { payload: JSON.parse(sessionStorage.getItem('tableState')) })
  yield call(GET_DEVICES_METRICS)
  yield put(deviceSetState({ loading: false, addMultipleDeviceStatus: 'success' }))
}

export function* REPLACE_DEVICES({ payload }) {
  // get clinic_id from payload
  // payload = { data: [{clinic_id: 1, device_id: 1}] }
  const clinicId = payload.data[0].clinic_id || payload.clinic_id
  payload.clinic_id = clinicId
  const { retry = false, force_create: forceCreate = false } = payload
  yield put(deviceSetState({ loading: true, replaceDevicesStatus: 'please wait' }))
  console.log('payload', payload, retry, forceCreate)
  const { err, res } = yield call(replaceDevices, payload, retry, forceCreate)
  if (err) {
    yield put(
      deviceSetState({
        loading: false,
        replaceDevicesStatus: 'error',
        replaceDevicesResponse: err,
      }),
    )
    return
  }
  const payloadData = JSON.parse(sessionStorage.getItem('tableState'))
  if (payloadData !== null) {
    yield call(GET_DEVICES, { payload: payloadData })
    yield call(GET_DEVICES_METRICS)
  }
  yield put(
    deviceSetState({
      loading: false,
      replaceDevicesStatus: 'success',
      replaceDevicesResponse: res,
    }),
  )
}

export function* REMOVE_DEVICE({ payload }) {
  yield put(deviceSetState({ loading: true }))
  console.log('payload', payload)
  const { err } = yield call(removeDevice, payload)
  if (err) return yield put(deviceSetState({ loading: false }))
  yield call(GET_DEVICES, { payload: JSON.parse(sessionStorage.getItem('tableState')) })
  yield call(GET_DEVICES_METRICS)
  yield put(deviceSetState({ loading: false }))
}

// Function to get Device Activity of a specific device and Save it in Redux Store
// import { getMemberDetail } from '../profile/actions'
// export function* GET_DEVICE_ACTIVITY({ payload }) {
//   const { deviceID } = payload
//   yield put(deviceSetState({ loading: true }))

//   const deviceActivity = yield call(getDeviceActivity, deviceID)
//   let deviceMember = {}
//   if (deviceActivity.length > 0) {
//     deviceMember = yield call(getMemberDetail, deviceActivity[0].user_id)
//   }
//   yield put(deviceSetState({ loading: false, deviceMember, deviceActivity }))
// }

// Function to get CLINIC Device Activity of a specific device and Save it in Redux Store
export function* GET_CLINIC_DEVICE_ACTIVITY({ payload }) {
  const { deviceID } = payload
  yield put(deviceSetState({ loading: true }))
  const deviceActivity = yield call(getClinicDeviceActivity, deviceID)
  yield put(deviceSetState({ loading: false, deviceActivity }))
}

// Function to add a New Device in Database and refresh the List Saved in Redux Store
export function* ADD_DEVICE(payload) {
  const { data } = payload
  yield put(deviceSetState({ formLoading: true, redirect: false, deviceForm: 'please wait' }))

  const { role } = yield select(getUser)
  const deviceForm = yield call(addDevice, data, role)
  yield put(deviceSetState({ formLoading: false, redirect: true, deviceForm }))
}

// Function to update a specific Device in Database and refresh the List Saved in Redux Store
export function* UPDATE_DEVICE(payload) {
  const { data } = payload
  yield put(deviceSetState({ formLoading: true, redirect: false, deviceForm: 'please wait' }))

  const { role } = yield select(getUser)
  const deviceForm = yield call(updateDevice, data, role)
  yield put(deviceSetState({ formLoading: false, redirect: true, deviceForm }))
}

// Function to add a New Device in Inventory and refresh the List Saved in Redux Store
export function* ADD_DEVICE_INVENTORY(payload) {
  const { data } = payload
  const { role } = yield select(getUser)
  yield put(deviceSetState({ modalLoading: true }))
  yield call(addDeviceInInventory, data, role)
  yield call(GET_INVENTORY_DEVICES, {
    payload: {
      status: 1,
    },
  })

  yield put(deviceSetState({ modalLoading: false, modalVisible: false }))
}

// Function to assign a specific device to a specific User and Refresh the Inventory in Redux Store
export function* ASSIGN_DEVICE_TO_USER({ payload }) {
  const { data } = payload
  const { role } = yield select(getUser)

  yield put(deviceSetState({ assignModalLoading: true }))

  yield call(assignDeviceToProvider, data, role)

  yield call(GET_INVENTORY_DEVICES, {
    payload: {
      status: 1,
    },
  })

  yield put(deviceSetState({ assignModalLoading: false, assignModalVisible: false }))
}

// Function to get a List of All the devices in Inventory Database and store it in Redux Store
export function* GET_INVENTORY_DEVICES({ payload }) {
  const { status } = payload
  yield put(deviceSetState({ inventoryLoading: true, inventoryDevices: [] }))
  const { role, details } = yield select(getUser)
  const recID = role === 'Superadmin' ? details.admin_id : details.user_id

  const inventoryDevices = yield call(getAllInventoryDevices, role, recID, status)

  let payloadToBeSent = {
    inventoryLoading: false,
    inventoryDevices,
  }
  if (status === 1) {
    payloadToBeSent = {
      inventoryLoading: false,
      inventoryDevices,
      inventoryDevicesList: inventoryDevices,
    }
  }
  yield put(deviceSetState(payloadToBeSent))
}

// Function to delete a Specific device from the DATABASE and refresh the list stored in Redux Store
export function* DELETE_INVENTORY_DEVICE({ payload }) {
  yield put(deviceSetState({ inventoryLoading: true }))
  const { data } = payload
  const { role } = yield select(getUser)
  yield call(deleteDevice, role, data)

  yield call(GET_INVENTORY_DEVICES, { payload: {} })
}

export function* GET_CLINIC_DEVICES({ payload }) {
  const { inventoryListingDevicesPageNumber } = payload
  yield put(
    deviceSetState({
      inventoryListingLoading: true,
      loading: true,
      inventoryListingDevicesPageNumber,
    }),
  )
  const { limit = 10, page = 1, setTotal = false, search } = payload
  const { userClinic } = yield select(getClinic)
  const { roomDirectoryActiveTab } = yield select(getDevice)
  const { id } = userClinic
  const data = {
    clinic_id: id,
    page,
    status: roomDirectoryActiveTab,
    search,
    limit,
  }
  const inventoryListingDevices = yield call(getInventoryDevices, data)

  const devices = inventoryListingDevices.data || []

  const { total_records: totalRecords = 0 } = inventoryListingDevices

  let payloadToBeSent = {
    loading: false,
    inventoryListingLoading: false,
    inventoryListingDevices,
    deviceMetrics: formatDeviceMetrics(devices, totalRecords),
  }

  if (setTotal) {
    payloadToBeSent = {
      ...payloadToBeSent,
      totalInventoryDeviceRecords: totalRecords,
    }
  }

  payloadToBeSent = {
    ...payloadToBeSent,
    inventoryListingDevicesPageSize: limit,
    inventoryListingDevicesPageNumber: page,
  }

  yield put(deviceSetState(payloadToBeSent))

  analytics.event({
    action: 'get_clinic_devices',
    category: 'room_dir',
    label: 'onPageLoad',
    value: data,
  })
}

export function* GET_CLINIC_DEVICES_DB() {
  yield put(deviceSetState({ inventoryLoading: true, loading: true }))

  const { userClinic } = yield select(getClinic)
  const { id } = userClinic
  let inventoryDevices = yield call(getDashboardDevices, { clinic_id: id })
  inventoryDevices = inventoryDevices.data
  yield put(deviceSetState({ inventoryLoading: false, loading: false, inventoryDevices }))
}
export function* GET_DEVICE_DETAIL({ payload }) {
  const { device_id: deviceID } = yield put(
    deviceSetState({ inventoryLoading: false, modalVisible: false }),
  )

  yield put(deviceSetState({ loading: true, deviceDetail: [] }))
  yield put(profileSetState({ nightByNightLoading: true }))
  const [deviceDetail] = yield all([
    call(getDeviceDetail, payload),
    call(GET_DEVICE_PATIENTS, { payload: { data: { device_id: deviceID } } }),
  ])
  yield put(deviceSetState({ loading: false, deviceDetail }))
}

export function* CHANGE_DEVICE_NAME({ data }) {
  yield put(deviceSetState({ deviceNameModalLoading: true }))
  const { userClinic } = yield select(getClinic)
  data.clinic_id = userClinic.id
  yield call(changeDeviceName, data)
  yield call(GET_CLINIC_DEVICES, { payload: { page: data.page } })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  yield put(deviceSetState({ deviceNameModalLoading: false, modalVisibleDeviceName: false }))
}

export function* CHANGE_DEVICE_ID({ payload }) {
  yield put(deviceSetState({ loading: true, replaceDevicesStatus: 'please wait' }))
  const { deviceObj, newDeviceID, clinicId, retry } = payload
  // console.log('deviceObj', deviceObj, payload)
  deviceObj.device_id = newDeviceID
  const newData = {
    0: newDeviceID,
    1: deviceObj.name,
    2: '1',
    3: deviceObj.floorName[0],
    4: deviceObj.fw_version,
    5: deviceObj.softap_ssid,
    6: deviceObj.mainObj.target_ssid,
  }
  // if (false) {
  const { err, res } = yield call(replaceDevices, { clinic_id: clinicId, data: [newData], retry })
  if (err) {
    yield put(
      deviceSetState({
        loading: false,
        replaceDevicesStatus: 'error',
        replaceDevicesResponse: err,
      }),
    )
    return
  }
  yield call(GET_DEVICES, { payload: JSON.parse(sessionStorage.getItem('tableState')) })
  yield call(GET_DEVICES_METRICS)
  yield put(
    deviceSetState({
      loading: false,
      replaceDevicesStatus: 'success',
      replaceDevicesResponse: res,
    }),
  )
  // }
}

export function* RETURN_DEVICE({ payload }) {
  yield put(deviceSetState({ inventoryLoading: true }))
  const { data } = payload

  yield call(returnDevice, data)

  yield call(GET_CLINIC_DEVICES, { payload: {} })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
}

export function* LINK_PATIENT({ payload }) {
  const { data } = payload
  const { userClinic } = yield select(getClinic)
  data.clinic_id = userClinic.id
  yield put(deviceSetState({ patientLinkLoading: true }))
  yield put(clinicPatientSetState({ patientLinkLoading: true }))
  yield call(linkPatient, data)
  yield put(deviceSetState({ patientLinkLoading: false, patientModalVisible: false }))

  yield put(clinicPatientSetState({ patientLinkLoading: false }))

  yield put(clinicPatientSetState({ isUnassignModalVisible: false }))

  yield call(GET_AVAILABLE_DEVICES)
  yield call(GET_CLINIC_PATIENTS, { payload: {} })
  yield call(GET_CLINIC_PATIENTS_DB, { payload: {} })
  yield call(GET_CLINIC_DEVICES, { payload: {} })

  analytics.event({
    action: 'udpate_resident',
    category: 'resident_room',
    label: 'Remove Room',
    value: data,
  })
}

export function* GET_DEVICE_PATIENTS({ payload }) {
  const { data } = payload

  yield put(deviceSetState({ devicePatientsLoading: true }))
  const devicePatients = yield call(getDevicePatientsList, data)

  return yield put(deviceSetState({ devicePatientsLoading: false, devicePatients }))
}

export function* SOCKET_DB_HANDLER({ payload }) {
  const { type } = payload
  const { token } = yield select(getUser)
  if (type === 'connect') {
    yield spawn(LISTEN_TO_DB_SOCKET, {
      payload: {
        jwtToken: token,
      },
    })
  } else {
    yield call(CLOSE_DB_SOCKET)
    const { inventoryDevices } = yield select(getDevice)
    inventoryDevices.map((item) => {
      item.rr_last_mint = { avg: null, max: null, min: null }
      item.rScore = { lower_score: 0, upper_score: 0 }

      return item
    })

    yield put(deviceSetState({ inventoryDevices }))
  }
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(DeviceActions.GET_DEVICES, GET_DEVICES),
    takeEvery(DeviceActions.GET_DEVICES_RECORDS, GET_DEVICES_RECORDS),
    takeEvery(DeviceActions.UPDATE_DEVICES_RECORDS_STATUS, UPDATE_DEVICES_RECORDS_STATUS),
    takeEvery(DeviceActions.GET_DEVICES_INVENTORY, GET_DEVICES_INVENTORY),
    takeEvery(DeviceActions.UPDATE_DEVICES_INVENTORY_STATUS, UPDATE_DEVICES_INVENTORY_STATUS),
    takeEvery(DeviceActions.GET_DEVICES_CONNECTION, GET_DEVICES_CONNECTION),
    takeEvery(DeviceActions.GET_DEVICES_METRICS, GET_DEVICES_METRICS),
    takeEvery(DeviceActions.ADD_SINGLE_DEVICE, ADD_SINGLE_DEVICE),
    takeEvery(DeviceActions.ADD_MULTIPLE_DEVICE, ADD_MULTIPLE_DEVICE),
    takeEvery(DeviceActions.REMOVE_DEVICE, REMOVE_DEVICE),
    takeEvery(DeviceActions.REPLACE_DEVICES, REPLACE_DEVICES),

    takeEvery(DeviceActions.ASSIGN_DEVICE_TO_USER, ASSIGN_DEVICE_TO_USER),
    // takeEvery(DeviceActions.GET_DEVICE_ACTIVITY, GET_DEVICE_ACTIVITY),
    takeEvery(DeviceActions.GET_CLINIC_DEVICE_ACTIVITY, GET_CLINIC_DEVICE_ACTIVITY),
    takeEvery(DeviceActions.ADD_DEVICE, ADD_DEVICE),
    takeEvery(DeviceActions.ADD_DEVICE_INVENTORY, ADD_DEVICE_INVENTORY),
    takeEvery(DeviceActions.UPDATE_DEVICE, UPDATE_DEVICE),
    takeEvery(DeviceActions.DELETE_INVENTORY_DEVICE, DELETE_INVENTORY_DEVICE),
    takeEvery(DeviceActions.GET_INVENTORY_DEVICES, GET_INVENTORY_DEVICES),

    // CLINIC MANAGEMENT DEVICE PROFILE APIs
    takeEvery(DeviceActions.GET_DEVICE_DETAIL, GET_DEVICE_DETAIL),
    takeEvery(DeviceActions.RETURN_DEVICE, RETURN_DEVICE),
    takeEvery(DeviceActions.GET_CLINIC_DEVICES, GET_CLINIC_DEVICES),
    takeEvery(DeviceActions.CHANGE_DEVICE_NAME, CHANGE_DEVICE_NAME),
    takeEvery(DeviceActions.LINK_PATIENT, LINK_PATIENT),
    takeEvery(DeviceActions.GET_DEVICE_PATIENTS, GET_DEVICE_PATIENTS),
    takeEvery(DeviceActions.SOCKET_DB_HANDLER, SOCKET_DB_HANDLER),
    takeEvery(DeviceActions.CHANGE_DEVICE_ID, CHANGE_DEVICE_ID),
  ])
}
